// Taille du texte : Corpus a repris notre réglage (leur PR #42, src/lib/fontScale.js, clé `mw_font_scale`). Notre copie
// (clé `cineforge.fontScale`) est retirée à la synchro du 30/10 ; ce module, importé AVANT src/lib/fontScale.js, reporte
// une fois le choix de l'utilisateur sur la nouvelle clé pour qu'il ne retombe pas à 100 %.
try {
  const old = localStorage.getItem("cineforge.fontScale");
  if (old !== null) {
    if (localStorage.getItem("mw_font_scale") === null) localStorage.setItem("mw_font_scale", old);
    localStorage.removeItem("cineforge.fontScale");
  }
} catch {
  // stockage bloqué : rien à reporter
}
